<div class="column full-width full-height">
    <div class="top-bar">
        <p-dropdown [appendTo]="null" [options]="spinnersCategories" [(ngModel)]="selectedCategory" optionLabel="Description"
            optionValue="Id">
        </p-dropdown>
    </div>

    <button class="custom-toggle-btn" [ngClass]="{'active': isCustomSpinner}" (click)="toggleCustomSpinner()">
        <span class="custom-toggle-icon">&#9998;</span>
        {{'ROULETTE.CUSTOM_SPINNER' | translate}}
        <span class="custom-toggle-arrow">{{ isCustomSpinner ? '&#9650;' : '&#9660;' }}</span>
    </button>

    <div *ngIf="isCustomSpinner" class="custom-spinner-panel column">

        <!-- COLORS SECTION -->
        <div class="custom-section-header">{{'ROULETTE.SECTION_COLORS' | translate}}</div>
        <div class="custom-section-body">
            <div class="color-picker-row row">
                <label>{{'ROULETTE.DARK_COLOR' | translate}}</label>
                <input type="color" [(ngModel)]="roulette.Design.CustomDarkColor" (ngModelChange)="onCustomColorChange()" />
            </div>
            <div class="color-picker-row row">
                <label>{{'ROULETTE.LIGHT_COLOR' | translate}}</label>
                <input type="color" [(ngModel)]="roulette.Design.CustomLightColor" (ngModelChange)="onCustomColorChange()" />
            </div>
        </div>

        <!-- BACKGROUND SECTION -->
        <div class="custom-section-header">{{'ROULETTE.SECTION_BACKGROUND' | translate}}</div>
        <div class="custom-section-body">
            <input #bgFileInput type="file" accept="image/*" style="display:none"
                (change)="onBgFileSelected($event)" />
            <button type="button" class="upload-bg-btn" (click)="bgFileInput.click()">
                <i class="pi pi-upload"></i>
                {{'ROULETTE.UPLOAD_BACKGROUND_IMAGE' | translate}}
            </button>
            <span *ngIf="bgUploadError" class="bg-upload-error">
                {{'ROULETTE.BG_FILE_TOO_LARGE' | translate}}
            </span>
            <span *ngIf="roulette.Design.CustomBackgroundImageUrl" class="bg-image-preview">
                <img [src]="roulette.Design.CustomBackgroundImageUrl" class="bg-thumb" />
                <button type="button" class="preview-bg-btn" (click)="previewCustomBackground()" pTooltip="{{'ROULETTE.VIEW_BACKGROUND_IMAGE' | translate}}">
                    <i class="pi pi-eye"></i>
                </button>
                <button type="button" class="remove-bg-btn" (click)="removeCustomBackground()" pTooltip="{{'ROULETTE.REMOVE_BACKGROUND' | translate}}">
                    <i class="pi pi-times"></i>
                </button>
            </span>
        </div>

        <!-- BUTTON SECTION -->
        <div class="custom-section-header">{{'ROULETTE.SECTION_BUTTON' | translate}}</div>
        <div class="custom-section-body">
            <div class="button-gallery">
                <button *ngFor="let btnUrl of spinnerButtonUrls"
                    type="button"
                    class="btn-option"
                    [ngClass]="{'selected-btn': roulette.Design.CustomButtonUrl === btnUrl}"
                    (click)="selectButton(btnUrl)">
                    <img [src]="btnUrl" alt="button" />
                </button>
            </div>
        </div>

    </div>

    <div class="ui-g container" *ngIf="!isCustomSpinner">
        <button *ngFor="let spinner of currentSpinners" class="design-setting-item"
            [ngClass]="{'selected-spinner': spinner.Id===selectedSpinnerId}" (click)="selectSpinner(spinner)">
            <img [src]="spinner.ThumbUrl" alt="Image" pTooltip="{{spinner.Description}}" />
            <span class="img-title">{{spinner.SpinnerName}}</span>
        </button>
    </div>
</div>